(() => {
  const money = (cents) => {
    const currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format((Number(cents) || 0) / 100); }
    catch (e) { return '$' + ((Number(cents) || 0) / 100).toFixed(2); }
  };
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const form = select.closest('.rue-product-form');
    if (!form) return;
    const variantData = form.querySelector('[data-product-variants]');
    if (!variantData) return;
    let variants = [];
    try { variants = JSON.parse(variantData.textContent || '[]'); } catch (e) {}
    const variant = variants.find((item) => String(item.id) === String(select.value));
    if (!variant) return;
    const idInput = form.querySelector('[name="id"]');
    if (idInput) idInput.value = variant.id;
    const price = form.querySelector('[data-product-price]');
    if (price) price.textContent = money(variant.price);
    const compare = form.querySelector('[data-product-compare]');
    if (compare) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compare.textContent = money(variant.compare_at_price);
        compare.hidden = false;
      } else { compare.hidden = true; }
    }
    const button = form.querySelector('[data-add-to-cart]');
    if (button) {
      button.disabled = !variant.available;
      const label = button.querySelector('[data-button-label]');
      if (label) label.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  });
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-mobile-toggle]');
    if (!toggle) return;
    const menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    const open = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
  });
  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-close-mobile]');
    if (!close) return;
    const menu = document.querySelector('[data-mobile-menu]');
    const toggle = document.querySelector('[data-mobile-toggle]');
    if (menu) menu.classList.remove('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  });
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.rue-newsletter .rue-form');
    if (!form) return;
    const email = form.querySelector('input[type="email"]');
    if (email && !email.value.trim()) { event.preventDefault(); email.focus(); }
  });
})();